import * as React from "react";
import * as styles from "./PeopleSearch.css";
import { Helper } from "../../../../Helper";
import { IAIcon } from "../../../icon/Icon";
import UserService from "../../../../services/UserService";
import { IAPersonaSmall } from "../../../personaSmall/PersonaSmall";
import { ICombinedUserResult } from "../../../../interfaces/ICombinedUserResult";
import { ISharePointUser } from "../../../../interfaces/ISharePointUser";
import { LocalizationService } from "../../../../services/LocalizationService";

export interface IPeopleSearchProps {
  environment: "Development" | "Test" | "Production";
  tenant: string;
  siteName: string;
  token: string;
  onSelect: (user: ISharePointUser) => void;
  placeholder: string;
  highlightColor?: string;
}

export interface IPeopleSearchState {
  userResult: ICombinedUserResult;
  isLoading: boolean;
  searchQuery: string;
}

export class PeopleSearch extends React.Component<IPeopleSearchProps, IPeopleSearchState> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IPeopleSearchProps, state: IPeopleSearchState) {
    super(props, state);
    this.state = {
      userResult: undefined,
      isLoading: false,
      searchQuery: ""
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): React.ReactElement<IPeopleSearchProps> {
    let suggestedPeople: JSX.Element[] = [];
    if (this.state.userResult != undefined && this.state.userResult.users != undefined) {
      this.state.userResult.users.forEach(user => {
        suggestedPeople.push(
          <div
            className={styles.suggestedPeopleItem}
            key={`suggestedPeopleItem_${user.userPrincipalName}`}
            onClick={() => {
              // Add person
              this.setState({ searchQuery: "", userResult: undefined });
              let inputField = document.getElementById("peopleSearchField");
              if (inputField) {
                inputField.focus();
              }
              this.props.onSelect(user);
            }}
          >
            <IAPersonaSmall
              name={user.title}
              metadata={Helper.getProfileOrGroupType(this.localizationService, user.loginName)}
              profileImage={Helper.getProfileOrGroupImage(this.props.environment, this.props.tenant, this.props.token, user.email, user.loginName)}
              highlightColor={this.props.highlightColor}
            />
          </div>
        );
      });
    }
    return (
      <div className={styles.peopleSearch}>
        <div className={styles.peopleSearchWrapper}>
          <input type="text" id="peopleSearchField" className={styles.peopleSearchField}
            value={this.state.searchQuery}
            placeholder={this.props.placeholder}
            onChange={async (evt) => {
              let searchQuery = evt.target.value;
              this.setState({ isLoading: true, searchQuery }, async () => {
                let searchQueryInput = this.state.searchQuery?.trim();
                if (searchQueryInput) {
                  let userResult = await UserService.getSharePointAndGraphCombinedUsers(this.props.environment, this.props.token, `${this.props.tenant}.sharepoint.com`, this.props.siteName, searchQueryInput);

                  // Trim string before comparing
                  let searchQueryResponse = userResult.searchQuery;
                  if (searchQueryResponse) { searchQueryResponse = searchQueryResponse.trim(); }

                  // Make sure we see the results from the latest search input
                  if ((this.state.searchQuery?.trim() == searchQueryResponse) || (!this.state.searchQuery?.trim() && !searchQueryResponse)) {
                    // Filter result with people already selected
                    // Graph does not support 'not equals' for Azure AD resources so we cannot do it server side
                    this.setState({ userResult, isLoading: false });
                  }
                }
                else {
                  const emptyUserResult: ICombinedUserResult = {
                    searchQuery: "",
                    users: []
                  };
                  this.setState({ isLoading: false, userResult: emptyUserResult });
                }
              });
            }}
          />
          {this.state.isLoading &&
            <div className={styles.spinner}>
              <IAIcon
                title="Spinner"
                size={20}
                color="#333333"
              />
            </div>
          }
        </div>
        {suggestedPeople.length > 0 &&
          <div className={styles.suggestedPeopleContainer}>
            {suggestedPeople}
          </div>
        }
      </div >
    );
  }
}